import { Avatar } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconAdjustments } from '@tabler/icons-react';

import { analyticsTypes } from '../../types';

import { AccordionLayout } from './AccordionLayout';
import { FilterForm } from './FilterForm';

type Props = {
  form: UseFormReturnType<analyticsTypes.GetManagerRepliesParams>;
  onSubmit: () => void;
};

export const ManagerRepliesFilter = ({ form, onSubmit }: Props) => {
  return (
    <AccordionLayout
      controlIcon={
        <Avatar size={40}>
          <IconAdjustments size={20} stroke={1.5} />
        </Avatar>
      }
      controlTitle={'Data filter'}
    >
      <FilterForm form={form} onSubmit={onSubmit} />
    </AccordionLayout>
  );
};
